(() => {
  if (window.louisLuxuryBuilder) return;
  window.louisLuxuryBuilder = true;
  function setup(root) {
    root.querySelectorAll('[data-lr-set]').forEach(section => {
      if (section.dataset.lrReady) return;
      section.dataset.lrReady = 'true';
      const config = JSON.parse(section.querySelector('[data-lr-config]').textContent);
      const button = section.querySelector('[data-lr-add]');
      const status = section.querySelector('[data-lr-status]');
      const total = section.querySelector('[data-lr-total]');
      let pending = false;
      const selected = () => [...section.querySelectorAll('.lr-set-card')].filter(card => card.querySelector('[data-lr-include]:checked:not(:disabled)')).map(card => card.querySelector('[data-lr-variant]')).filter(select => select && !select.disabled && select.selectedOptions[0] && !select.selectedOptions[0].disabled);
      function update() {
        const items = selected();
        const amount = items.reduce((sum, select) => sum + Number(select.selectedOptions[0].dataset.price || 0), 0);
        try { total.textContent = new Intl.NumberFormat(config.locale, { style: 'currency', currency: config.currency }).format(amount / 100); }
        catch { total.textContent = `${(amount / 100).toFixed(2)} ${config.currency}`; }
        button.disabled = pending || !items.length;
      }
      section.addEventListener('change', update);
      button.addEventListener('click', async () => {
        if (pending) return;
        const variants = selected();
        if (!variants.length) { status.textContent = config.empty; return; }
        const quantities = new Map();
        variants.forEach(select => quantities.set(select.value, (quantities.get(select.value) || 0) + 1));
        const items = [...quantities].map(([id, quantity]) => ({ id, quantity }));
        pending = true;
        status.textContent = '';
        button.setAttribute('aria-busy', 'true');
        update();
        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
          const result = await response.json();
          if (!response.ok || result.status >= 400) throw new Error(typeof result.description === 'string' ? result.description : config.error);
          window.location.assign(config.cart);
        } catch (error) {
          status.textContent = error.message || config.error;
          pending = false;
          button.removeAttribute('aria-busy');
          update();
        }
      });
      update();
    });
  }
  setup(document);
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();
